export var OrderFieldsByStrategy;
(function (OrderFieldsByStrategy) {
    OrderFieldsByStrategy["LABEL"] = "LABEL";
    OrderFieldsByStrategy["INDEX"] = "INDEX";
})(OrderFieldsByStrategy || (OrderFieldsByStrategy = {}));
//# sourceMappingURL=table.js.map